export default "__VITE_ASSET__CfV9zzJF__"